import { Share2 } from 'lucide-react'
import Button from '@/components/ui/Button'
import { useToast } from '@/components/ui/toast'

/** The customer's public tracking link with a copy button. Shared by the shipment and booking modals. */
export default function TrackingLinkBox({ shareToken }: { shareToken: string }) {
  const toast = useToast()
  const url = `${window.location.origin}/track/${shareToken}`

  return (
    <div className="rounded-lg border border-line bg-app p-3">
      <p className="text-xs font-semibold">Customer tracking link</p>
      <p className="mt-1 break-all font-mono text-2xs text-muted">{url}</p>
      <Button
        variant="outline"
        className="mt-2"
        onClick={async () => {
          await navigator.clipboard.writeText(url)
          toast.success('Tracking link copied', 'Send it to the customer - no sign-in needed to view.')
        }}
      >
        <Share2 className="size-4" /> Copy link
      </Button>
    </div>
  )
}
